export default __webpack_public_path__ + "static/media/chart-closest-distribution-1_LS.791b449d.png";